import { useEffect, useState } from "react";
import { Bars3CenterLeftIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import Hum from "@/ui/atoms/Icon/Hum";

interface MobileNavbarProps {
    onMenuClick?: () => void;
}

export const MobileNavbar = ({ onMenuClick }: MobileNavbarProps) => {
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            setIsScrolled(scrollTop > 20);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <div
            className={clsx(
                "fixed inset-x-0 top-0 z-50",
                "block lg:hidden",
                "bg-slate-800 text-white",
                "transition-all duration-300 ease-in-out",
            )}
        >
            <div
                className={clsx(
                    "p-6",
                    "flex items-center justify-between",
                    "relative",
                )}
            >
                <div className="flex items-center">
                    <Hum className="size-[32px]" width="32" height="32" />
                </div>

                <button
                    onClick={onMenuClick}
                    className="menu-item"
                    aria-label="Open menu"
                >
                    <Bars3CenterLeftIcon className="size-8" />
                </button>
            </div>

            {isScrolled && (
                <div
                    className={clsx(
                        "absolute inset-x-0 -bottom-8 h-12",
                        "bg-gradient-to-b from-slate-800 from-30% via-slate-800/50 via-50% to-slate-800/5 to-100%",
                        "pointer-events-none",
                    )}
                />
            )}
        </div>
    );
};
